import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from './assets/images/logo.png';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/rfs.css';
import * as myConstClass from './constant.js';
import { sendGuestOrderConfirmationEmail } from './constant.js';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';
import NewHeader from './newHeader.js';
import Footer from './Footer.js';
import { Editor } from 'react-draft-wysiwyg';
import $ from 'jquery';

// Translation Higher Order Component
import {
    setTranslations,
    setDefaultLanguage,
    setLanguageCookie,
    setLanguage, getLanguage,
    translate,
    t,
} from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import PropTypes from 'prop-types';

import {
    Row,
    Col,
    Card,
    ListGroup,
    ListGroupItem
} from "reactstrap";

// Guest order helpers
import { getGuestOrderById, formatOrderDate, completePendingGuestOrder } from './utils/guestOrderHelpers.js';
import { tr } from 'date-fns/locale';
class Orderdetails extends Component {

    constructor(props) {
        super(props);
        this.product_id = 0;
        this.state = {
            cart: [],
            eventitem: [],
            eventTestitem: [],
            country: [],
            country_state: [],
            city: [],
            event: [],
            productitem: [],
            magazineitem: [],
            getOrderShippingAddress: [],
            getOrderBillingAddress: [],
            detailsarray: [],
            flag: 0,
            eventinfo: {
                transaction_id: '',
                status: '',
                total_price: '',
                comment: '',
                created_on: '',
                name: '',
                mobile: '',
                order_id: '',
                order_id_main: ''
            },
            cancelinfo: {
                status: '',
                message: '',
            },
            // 'success' | 'failed' | 'cancelled'
            // Drives the success/fail/cancelled UI — do NOT use jQuery to toggle those elements.
            orderDisplayStatus: 'success',

            // true if current user is a guest (no valid user_id in localStorage)
            isGuestUser: false,

            editorState: EditorState.createEmpty(),
        }

        this.handleChange = this.handleChange.bind(this);
        this.cancelOrder = this.cancelOrder.bind(this);
        this.cancelOrderConfirm = this.cancelOrderConfirm.bind(this);
        this.fetchGuestOrderFromPHP = this.fetchGuestOrderFromPHP.bind(this);
        this.fetchEventOrderFromNode = this.fetchEventOrderFromNode.bind(this);

        this.translateOr = this.translateOr.bind(this);

    }

    // Safe translation helper with fallback when key is missing
    translateOr(key, fallback) {
        try {
            const val = (this.props && this.props.t) ? this.props.t(key) : t(key);
            if (!val) return fallback;
            const s = val.toString();
            // If translation returns the key (e.g., "home.WhatsApp..."), use fallback
            if (s.indexOf('home.') === 0 || s.indexOf(key) === 0) return fallback;
            return s;
        } catch (e) {
            return fallback;
        }
    }

    isNumericOrderId(orderId) {
        return /^[0-9]+$/.test(String(orderId || '').trim());
    }

    fetchNodeOrderDetails(orderId, options = {}) {
        const fetchOptions = options || {};
        const endpoint = this.isNumericOrderId(orderId)
            ? `${myConstClass.NODE_API_BASE}/order/by-id/${orderId}`
            : `${myConstClass.NODE_API_BASE}/order/${orderId}`;

        return fetch(endpoint, fetchOptions)
            .then(response => {
                if (response.status === 404 && !this.isNumericOrderId(orderId)) {
                    return fetch(`${myConstClass.NODE_API_BASE}/order/by-id/${orderId}`, fetchOptions)
                        .then(r => r.json());
                }
                return response.json();
            });
    }

    // Helper method to fetch event order from Node.js API
    // Numeric IDs must use /order/by-id/:id. /order/:id expects order_id_main (W_...).
    fetchEventOrderFromNode(orderId, existingResult, successMessage) {
        return Promise.resolve(existingResult || this.fetchNodeOrderDetails(orderId))
            .then(result => {
                if (result.status === 'true' && result.data) {
                    const { order, items, participants, billing, shipping } = result.data;
                    const mappedStatus = this.mapOrderStatus(order.status);
                    
                    // Transform and separate event items with participants FIRST
                    const transformedItems = items.map(item => {
                        // Calculate participant counts from actual participants array
                        const itemParticipants = item.participants || [];
                        const participantCount = itemParticipants.length;
                        
                        // Group participants by type dynamically
                        const participantsByType = {};
                        itemParticipants.forEach(p => {
                            const type = p.type || '1';
                            participantsByType[type] = (participantsByType[type] || 0) + 1;
                        });
                        
                        // Calculate item total - prefer API's item total_price if available
                        let itemTotalPrice = item.total_price || item.item_total || 0;
                        
                        // If no item total from API, calculate from participants using price type mapping
                        if (!itemTotalPrice && itemParticipants.length > 0) {
                            // If participants have individual prices, sum them
                            const hasParticipantPrices = itemParticipants.some(p => p.price || p.amount);
                            if (hasParticipantPrices) {
                                itemTotalPrice = itemParticipants.reduce((sum, p) => sum + (p.price || p.amount || 0), 0);
                            } else {
                                // Match participant types to price types
                                // first_price_for and second_price_for should have type values
                                const firstPriceType = item.first_price_for_type || item.first_price_for || '1';
                                const secondPriceType = item.second_price_for_type || item.second_price_for || '2';
                                
                                const firstTypeCount = participantsByType[firstPriceType] || 0;
                                const secondTypeCount = participantsByType[secondPriceType] || 0;
                                
                                itemTotalPrice = (item.first_price || 0) * firstTypeCount + 
                                               (item.second_price || 0) * secondTypeCount;
                            }
                        }
                        
                        // Legacy fallback for backward compatibility
                        if (!itemTotalPrice) {
                            itemTotalPrice = (item.first_price || 0) * (item.parent || 0) + 
                                           (item.second_price || 0) * (item.child || 0);
                        }
                        
                        return {
                            order_item_id: item.order_item_id,
                            product_id_fk: item.product_id_fk,
                            event_id_fk: item.event_id_fk,
                            // schedule id may be present under multiple keys depending on API
                            schedule_id: item.schedule_id || item.scheduleId || item.event_schedule_id || item.schedule_id_fk || item.scheduleIdFk || null,
                            title: item.event_title,
                            // Prefer explicit event type returned by the Node API (several possible field names),
                            // fall back to mapping by event id when not provided.
                            event_type: item.event_type || item.event_type_name || item.event_type_title || item.type || this.mapEventType(item.event_id_fk),
                            event_language: 'English',
                            city_name: item.city_name || item.venue_address,
                            venue_address: item.venue_address,
                            start_date: item.start_date,
                            end_date: item.end_date,
                            // Store participant counts by type (for backward compatibility)
                            parent: participantsByType['1'] || item.parent || 0,
                            child: participantsByType['2'] || item.child || 0,
                            couple: participantsByType['3'] || item.couple || 0,
                            price: item.first_price || item.price,
                            second_price: item.second_price || 0,
                            first_price_for: item.first_price_for || 'Adult',
                            second_price_for: item.second_price_for || 'Child',
                            quantity: item.quantity,
                            trust_name: item.trust_name,
                            trust_id_fk: item.trust_id_fk,
                            is_product_event: item.is_product_event,
                            // Include participants data for display
                            participants: itemParticipants,
                            participants_count: participantCount,
                            participants_by_type: participantsByType,
                            // Store calculated item total
                            item_total: itemTotalPrice,
                            // WhatsApp link from backend (event_schedule.whatsapp_link)
                            whatsapp_link: item.whatsapp_link || null
                        };
                    });
                    
                    // Calculate correct total from items - use item_total if available
                    const calculatedTotal = transformedItems.reduce((sum, item) => {
                        // Prefer item_total if calculated, otherwise use old formula
                        if (item.item_total) {
                            return sum + item.item_total;
                        }
                        return sum + (item.price * item.parent) + (item.second_price * item.child);
                    }, 0);
                    
                    // Update event-specific fields WITHOUT overwriting detailsarray
                    // Preserve existing detailsarray to avoid race conditions
                    // Use calculated total if API total is wrong
                    const correctTotalPrice = calculatedTotal || order.total_price || order.event_total_price;
                    
                    this.setState({
                        eventinfo: {
                            ...this.state.eventinfo,
                            transaction_id: order.transaction_id || order.bank_ref_no || 'N/A',
                            order_id_main: order.order_id_main,
                            status: mappedStatus,
                            total_price: correctTotalPrice,
                            created_on: order.created_on,
                            order_id: order.order_id
                        }
                    });
                    
                    // If detailsarray is empty or only has error, populate it
                    if (!this.state.detailsarray || this.state.detailsarray.length === 0 || this.state.detailsarray[0].error) {
                        this.setState({
                            detailsarray: [{
                                order_id: order.order_id,
                                order_id_main: order.order_id_main,
                                receipt_number: order.receipt_number,
                                user_id_fk: order.user_id_fk,
                                transaction_id: order.transaction_id || order.bank_ref_no || 'N/A',
                                bank_ref_no: order.bank_ref_no,
                                status: mappedStatus,
                                total_price: correctTotalPrice,
                                comment: order.comment || '',
                                delivery_type: order.delivery_type,
                                shipping_charges: order.shipping_charges || 0,
                                courier_date: order.courier_date,
                                courier_url: order.courier_url,
                                courier_url_available: order.courier_url ? 1 : 0,
                                created_on: order.created_on,
                                courier_date_format: order.courier_date,
                                order_type: 'event'
                            }]
                        });
                    }

                    this.applyOrderDisplayStatus(mappedStatus, successMessage);
                    
                    // Separate machine test events (is_product_event='3') from regular events (is_product_event='2')
                    const eventItems = transformedItems.filter(item => item.is_product_event !== '3');
                    const machineTestItems = transformedItems.filter(item => item.is_product_event === '3');
                    
                    // Check if this order contains machine tests
                    const hasMachineTests = machineTestItems.length > 0;
                    
                    this.setState({ 
                        eventitem: eventItems,
                        eventTestitem: machineTestItems
                    });
                    
                    // MACHINE TEST ADDRESS HANDLING:
                    // Machine tests may be created via PHP cart checkout (addresses in PHP DB)
                    // OR via Node.js event booking flow (addresses in Node.js response).
                    // Try PHP first; if empty, fall back to Node.js billing data.
                    if (hasMachineTests && localStorage.getItem('last_order_source') !== 'node_event') {
                        fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + orderId + '/1')
                            .then(r => r.json())
                            .then(r => {
                                const phpBilling = r && r.find(a => a.type === "1" || a.type === "3");
                                const phpShipping = r && r.find(a => a.type === "2");
                                if (phpBilling) {
                                    // PHP has address data (cart-checkout machine tests)
                                    this.setState({ 
                                        getOrderBillingAddress: [phpBilling],
                                        getOrderShippingAddress: phpShipping ? [phpShipping] : []
                                    });
                                } else if (billing) {
                                    // PHP returned empty — use Node.js billing data (event-booking machine tests)
                                    this.setState({
                                        getOrderBillingAddress: [{
                                            type: '1',
                                            first_name: billing.firstName,
                                            last_name: billing.lastName,
                                            middle_name: billing.middleName,
                                            address_line_1: billing.address1,
                                            address_line_2: billing.address2,
                                            address_1: billing.address1,
                                            address_2: billing.address2,
                                            city_id_fk: billing.cityIdFk,
                                            state_id_fk: billing.stateIdFk,
                                            country_id_fk: billing.countryIdFk,
                                            city_name: billing.cityName || billing.address1 || '',
                                            state_name: billing.stateName || '',
                                            country_name: billing.countryName || 'India',
                                            pincode: billing.pincode,
                                            mobile: billing.mobile,
                                            phone: billing.mobile,
                                            email: billing.email,
                                            company: billing.company || '',
                                            landmark: billing.landmark || ''
                                        }]
                                    });
                                }
                            })
                            .catch(() => {
                                // PHP fetch failed — fall back to Node.js billing data
                                if (billing) {
                                    this.setState({
                                        getOrderBillingAddress: [{
                                            type: '1',
                                            first_name: billing.firstName,
                                            last_name: billing.lastName,
                                            middle_name: billing.middleName,
                                            address_line_1: billing.address1,
                                            address_line_2: billing.address2,
                                            address_1: billing.address1,
                                            address_2: billing.address2,
                                            city_id_fk: billing.cityIdFk,
                                            state_id_fk: billing.stateIdFk,
                                            country_id_fk: billing.countryIdFk,
                                            city_name: billing.cityName || billing.address1 || '',
                                            state_name: billing.stateName || '',
                                            country_name: billing.countryName || 'India',
                                            pincode: billing.pincode,
                                            mobile: billing.mobile,
                                            phone: billing.mobile,
                                            email: billing.email,
                                            company: billing.company || '',
                                            landmark: billing.landmark || ''
                                        }]
                                    });
                                }
                            });
                    }
                    // NORMAL EVENT ADDRESS HANDLING:
                    // Normal events use Node.js booking flow, addresses come from Node.js API
                    else if (billing) {
                        this.setState({
                            getOrderBillingAddress: [{
                                type: '1',
                                first_name: billing.firstName,
                                last_name: billing.lastName,
                                middle_name: billing.middleName,
                                address_line_1: billing.address1,
                                address_line_2: billing.address2,
                                address_1: billing.address1,
                                address_2: billing.address2,
                                city_id_fk: billing.cityIdFk,
                                state_id_fk: billing.stateIdFk,
                                country_id_fk: billing.countryIdFk,
                                city_name: billing.cityName || billing.address1 || '',
                                state_name: billing.stateName || '',
                                country_name: billing.countryName || 'India',
                                pincode: billing.pincode,
                                mobile: billing.mobile,
                                phone: billing.mobile,
                                email: billing.email,
                                company: billing.company || '',
                                landmark: billing.landmark || ''
                            }]
                        });
                        
                        if (shipping) {
                            this.setState({
                                getOrderShippingAddress: [{
                                    type: '2',
                                    first_name: shipping.firstName,
                                    last_name: shipping.lastName,
                                    middle_name: shipping.middleName,
                                    address_line_1: shipping.address1,
                                    address_line_2: shipping.address2,
                                    address_1: shipping.address1,
                                    address_2: shipping.address2,
                                    city_id_fk: shipping.cityIdFk,
                                    state_id_fk: shipping.stateIdFk,
                                    country_id_fk: shipping.countryIdFk,
                                    city_name: shipping.cityName || shipping.address1 || '',
                                    state_name: shipping.stateName || '',
                                    country_name: shipping.countryName || 'India',
                                    pincode: shipping.pincode,
                                    mobile: shipping.mobile,
                                    phone: shipping.mobile,
                                    email: shipping.email,
                                    company: shipping.company || '',
                                    landmark: shipping.landmark || ''
                                }]
                            });
                        }
                    }
                    
                    return true;
                }
            })
            .catch(() => {
                return false;
            });
    }

    // Helper method to map order status from numeric to text
    mapOrderStatus(status) {
        const statusMap = {
            '1': 'Pending',
            '2': 'Confirm',
            '3': 'Dispatched',
            '4': 'Delivered',
            '5': 'Cancelled',
            '6': 'Returned'
        };
        return statusMap[status] || status;
    }

    applyOrderDisplayStatus(status, successMessage) {
        const message = (successMessage || '').toLowerCase();
        const mappedStatus = this.mapOrderStatus(status);

        if (message.includes('fail')) {
            this.setState({ orderDisplayStatus: 'failed' });
        } else if (message.includes('cancel')) {
            this.setState({ orderDisplayStatus: 'cancelled' });
        } else if (mappedStatus === 'Pending') {
            this.setState({ orderDisplayStatus: 'failed' });
        } else if (mappedStatus === 'Cancelled') {
            this.setState({ orderDisplayStatus: 'cancelled' });
        } else {
            this.setState({ orderDisplayStatus: 'success' });
        }
    }

    getResolvedOrderSource(orderId) {
        const explicitSource = localStorage.getItem('last_order_source');
        if (explicitSource === 'node_event' || explicitSource === 'php_cart') {
            return explicitSource;
        }

        return null;
    }

    loadNodeOrder(orderId, userId, successMessage) {
        return this.fetchNodeOrderDetails(orderId, { cache: 'no-cache' })
            .then(result => {
                if (!(result.status === 'true' && result.data && result.data.order)) {
                    throw new Error('Order not found');
                }

                const order = result.data.order;
                if (userId && order.user_id_fk != userId) {
                    throw new Error('User does not own this order');
                }

                return this.fetchEventOrderFromNode(orderId, result, successMessage);
            })
            .catch(() => {
                toast('Unable to load order details', { containerId: 'B', type: toast.TYPE.ERROR });
                this.setState({
                    detailsarray: [{ error: true, message: 'Unable to load order details' }],
                    productitem: [],
                    magazineitem: [],
                    eventitem: [],
                    eventTestitem: [],
                    orderDisplayStatus: 'failed'
                });
            });
    }

    loadUnknownOrder(orderId, userId, isGuestUser, successMessage) {
        const guestOrder = isGuestUser ? getGuestOrderById(orderId) : null;

        if (guestOrder) {
            const formattedOrder = {
                order_id: guestOrder.order_id,
                order_id_main: guestOrder.order_id_main,
                transaction_id: guestOrder.transaction_id,
                status: guestOrder.status,
                total_price: guestOrder.total_price,
                created_on: guestOrder.created_on,
                payment_mode: guestOrder.payment_mode,
                delivery_type: guestOrder.delivery_type
            };

            this.setState({
                detailsarray: [formattedOrder],
                productitem: guestOrder.products || [],
                magazineitem: guestOrder.magazines || [],
                eventitem: guestOrder.events || [],
                eventTestitem: guestOrder.machineTestEvents || [],
                getOrderBillingAddress: [guestOrder.billing_address] || [],
                getOrderShippingAddress: [guestOrder.shipping_address] || []
            });
        }

        return this.fetchGuestOrderFromPHP(orderId, guestOrder, true)
            .then(foundInPhp => {
                if (foundInPhp) {
                    localStorage.setItem('last_order_source', 'php_cart');
                    localStorage.removeItem('last_booking_id');
                    return true;
                }

                localStorage.setItem('last_order_source', 'node_event');
                return this.loadNodeOrder(orderId, userId, successMessage);
            });
    }

    // Format created_on to show only date (no time)
    formatDateOnly(createdOn) {
        if (!createdOn) return '';
        try {
            // If it's a datetime string like 'YYYY-MM-DD HH:MM:SS', take the date part
            let datePart = createdOn;
            if (typeof createdOn === 'string' && createdOn.indexOf(' ') !== -1) {
                datePart = createdOn.split(' ')[0];
            }
            const d = new Date(datePart);
            if (!isNaN(d.getTime())) {
                return d.toLocaleDateString();
            }
            return datePart;
        } catch (err) {
            return createdOn;
        }
    }

    // Helper method to map event type
    // Note: This is a fallback. The API should provide event_type in the response.
    mapEventType(eventId) {
        // This method is deprecated - use is_product_event field instead
        // is_product_event: '2' = Event, '3' = Machine Test
        if (eventId === 83) return 'Machine Test';
        return 'Event'; // Default fallback
    }

    // Fetch WhatsApp links for a given schedule id from Node.js booking API
    fetchWhatsappLinkForSchedule(scheduleId) {
        const sid = parseInt(scheduleId, 10);
        if (isNaN(sid)) {
            return Promise.reject(new Error('Valid schedule ID is required'));
        }

        const url = `${myConstClass.NODE_API_BASE}/booking/getWhatsappLinksBySchedule/${sid}`;
        return fetch(url, { cache: 'no-cache' })
            .then(r => r.json())
            .then(body => {
                if (body && (body.status === 'true' || body.status === true) && body.data) {
                    this.setState(prev => ({
                        whatsappLinksBySchedule: {
                            ...(prev.whatsappLinksBySchedule || {}),
                            [sid]: body.data
                        }
                    }));
                    return body.data;
                }

                // On non-success response, store null for this schedule to avoid repeated attempts
                this.setState(prev => ({
                    whatsappLinksBySchedule: {
                        ...(prev.whatsappLinksBySchedule || {}),
                        [sid]: null
                    }
                }));
                return null;
            })
            .catch(err => {
                this.setState(prev => ({
                    whatsappLinksBySchedule: {
                        ...(prev.whatsappLinksBySchedule || {}),
                        [sid]: null
                    }
                }));
                throw err;
            });
    }

    // Helper method to fetch guest order from PHP payment API (for products)
    fetchGuestOrderFromPHP(orderId, guestOrder, suppressNotFound = false) {
        // First, determine order type from guestOrder or fetch main order details
        return fetch(myConstClass.BASE_URL + 'payment/getOrderDetails/' + orderId + '/' + getLanguage())
            .then(response => response.json())
            .then(response => {
                if (response && response[0]) {
                    const orderType = response[0].order_type;
                    
                    // Update main order details
                    this.setState({ detailsarray: response });
                    this.setState({
                        eventinfo: {
                            ...this.state.eventinfo,
                            transaction_id: response[0].transaction_id,
                            order_id_main: response[0].order_id_main,
                            status: response[0].status,
                            total_price: response[0].total_price,
                            created_on: response[0].created_on
                        }
                    });
                    this.applyOrderDisplayStatus(response[0].status);
                    
                    // Only legacy PHP event/mixed orders should ask Node for event details.
                    // Node event orders are routed before this method is called.
                    if (!localStorage.getItem('last_order_source') && (orderType === 'event' || orderType === 'mixed')) {
                        this.fetchEventOrderFromNode(orderId).then(success => {
                            // Event data fetched or failed silently
                        });
                    }
                    
                    // If order contains products or magazines, fetch from PHP API
                    if (orderType === 'product' || orderType === 'magazine' || orderType === 'mixed' || !orderType) {
                        fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsItem/' + orderId + '/' + getLanguage())
                            .then(r => r.json()).then(r => this.setState({ productitem: r }))
                            .catch(() => {});
                        fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsMagazineItem/' + orderId + '/' + getLanguage())
                            .then(r => r.json()).then(r => this.setState({ magazineitem: r }))
                            .catch(() => {});
                        fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + orderId + '/1')
                            .then(r => r.json()).then(r => {
                                this.setState({ 
                                    getOrderBillingAddress: r.find(a => a.type === "1" || a.type === "3") ? [r.find(a => a.type === "1" || a.type === "3")] : [],
                                    getOrderShippingAddress: r.find(a => a.type === "2") ? [r.find(a => a.type === "2")] : []
                                });
                            }).catch(() => {});
                    }
                    return true;
                } else {
                    const hasLoadedOrder = this.state.detailsarray &&
                        this.state.detailsarray.length > 0 &&
                        !this.state.detailsarray[0].error;

                    if (guestOrder || hasLoadedOrder) {
                        return true;
                    }

                    if (suppressNotFound) {
                        return false;
                    }

                    toast('Order not found', { containerId: 'B', type: toast.TYPE.ERROR });
                    this.setState({
                        detailsarray: [{ error: true, message: 'Order not found', order_id: orderId }],
                        productitem: [],
                        magazineitem: [],
                        eventitem: [],
                        eventTestitem: []
                    });
                    this.setState({ orderDisplayStatus: 'failed' });
                    return false;
                }
            })
            .catch(err => {
                // Keep localStorage data on error
                const hasLoadedOrder = this.state.detailsarray &&
                    this.state.detailsarray.length > 0 &&
                    !this.state.detailsarray[0].error;

                if (!guestOrder && !hasLoadedOrder) {
                    toast('Order not found', { containerId: 'B', type: toast.TYPE.ERROR });
                    this.setState({
                        detailsarray: [{ error: true, message: 'Order not found' }],
                        productitem: [],
                        magazineitem: [],
                        eventitem: [],
                        eventTestitem: [],
                        orderDisplayStatus: 'failed'
                    });
                }
                return false;
            });
    }

    componentDidMount() {
        var current_language = getLanguage();
        localStorage.setItem('current_language', current_language);
        
    // Determine if current user is a guest (no valid user_id in localStorage)
    // This is the authoritative check used throughout the render to show/hide order details
    const loggedInUserId = localStorage.getItem('user_id');
    const isGuestUser = !loggedInUserId || loggedInUserId == '0';
    this.setState({ isGuestUser });

    // Check if this is a guest user after payment success
    const isGuestAutoCreated = localStorage.getItem('isGuestAutoCreated');
    const answer_array = this.props.location.pathname.split('/');
    // Derive orderId from path segment, query param fallback, or previously saved localStorage
    const queryParams = new URLSearchParams(this.props.location.search);
    const pathOrderId = answer_array[2];
    const queryOrderId = queryParams.get('order_id');
    let orderId = pathOrderId || queryOrderId || localStorage.getItem('last_displayed_order_id');
    const successMessage = answer_array['3'];

        // Clear event checkout in progress flag when order is successfully placed
        // This prevents events from being removed from cart when user completes checkout
        if (orderId && successMessage && (successMessage.includes('completed successfully') || successMessage.includes('successful'))) {
            localStorage.removeItem('event_checkout_in_progress');
            localStorage.removeItem('address_proceeding_to_checkout');
            // Clear the booking_event data after successful payment
            localStorage.removeItem('booking_event');
            localStorage.removeItem('booking_event_guest');
            localStorage.removeItem('guest_event_participants');
        }

        // Persist orderId early so it's available even if pending order is missing
        if (orderId) {
            try {
                localStorage.setItem('last_displayed_order_id', orderId);
                // Initialize eventinfo in state so template bindings show immediately
                this.setState(prev => ({
                    eventinfo: {
                        ...prev.eventinfo,
                        order_id: orderId,
                        order_id_main: orderId
                    }
                }));
            } catch (e) {
            }
            
            const guest_email = localStorage.getItem('guest_email');
            const orderIdMain = localStorage.getItem('last_displayed_order_id');
            const firstName = localStorage.getItem('guest_first_name');
            const user_type = localStorage.getItem('continue_as_guest')? 'guest' : 'register';
            const guest_userId = localStorage.getItem('guest_user_id_temp');
            if(orderIdMain && guest_userId && firstName && guest_email){
                try {
                    sendGuestOrderConfirmationEmail({
                        email: guest_email,
                        orderIdMain: orderIdMain,
                        firstName: firstName,
                        user_type: user_type,
                        userId: guest_userId,
                    });
                } catch (error) {
                }
            }

            const resolvedOrderSource = this.getResolvedOrderSource(orderId);
            if (resolvedOrderSource) {
                const userIdForOwnership = isGuestUser ? null : loggedInUserId;

                if (resolvedOrderSource === 'node_event') {
                    this.loadNodeOrder(orderId, userIdForOwnership, successMessage);
                    return;
                }

                if (resolvedOrderSource === 'php_cart') {
                    const guestOrder = isGuestUser ? getGuestOrderById(orderId) : null;
                    if (guestOrder) {
                        const formattedOrder = {
                            order_id: guestOrder.order_id,
                            order_id_main: guestOrder.order_id_main,
                            transaction_id: guestOrder.transaction_id,
                            status: guestOrder.status,
                            total_price: guestOrder.total_price,
                            created_on: guestOrder.created_on,
                            payment_mode: guestOrder.payment_mode,
                            delivery_type: guestOrder.delivery_type
                        };

                        this.setState({
                            detailsarray: [formattedOrder],
                            productitem: guestOrder.products || [],
                            magazineitem: guestOrder.magazines || [],
                            eventitem: guestOrder.events || [],
                            eventTestitem: guestOrder.machineTestEvents || [],
                            getOrderBillingAddress: [guestOrder.billing_address] || [],
                            getOrderShippingAddress: [guestOrder.shipping_address] || []
                        });
                    }

                    this.fetchGuestOrderFromPHP(orderId, guestOrder);
                    localStorage.removeItem('last_booking_id');
                    return;
                }
            }

            this.loadUnknownOrder(orderId, isGuestUser ? null : loggedInUserId, isGuestUser, successMessage);
            return;

            // If a logged-in user exists, fetch order details immediately using the same endpoints
            if (loggedInUserId && loggedInUserId !== '0') {
                // Use the same backend endpoints already used elsewhere in this file
                fetch(myConstClass.BASE_URL + 'payment/getOrderDetails/' + orderId + '/' + getLanguage())
                    .then(response => response.json())
                    .then(response => {
                        if (response && response[0] && response[0].user_id_fk == localStorage.getItem('user_id')) {
                            this.setState({ detailsarray: response });
                            this.setState({
                                eventinfo: {
                                    ...this.state.eventinfo,
                                    transaction_id: response[0].transaction_id,
                                    order_id_main: response[0].order_id_main
                                }
                            });
                        }
                    }).catch(() => {});

                fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsItem/' + orderId + '/' + getLanguage())
                    .then(response => response.json())
                    .then(response => {
                        this.setState({ productitem: response });
                    }).catch(() => {});

                fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsMagazineItem/' + orderId + '/' + getLanguage())
                    .then(response => response.json())
                    .then(response => {
                        this.setState({ magazineitem: response });
                    }).catch(() => {});

                // NOTE: fetchEventOrderFromNode is NOT called here unconditionally.
                // It is called only inside the main flow below, after confirming this is an event order
                // via the Node.js API ownership check. Calling it here caused product orders to pick up
                // unrelated old event data from Node.js when the orderId matched a different event.

                fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + orderId + '/1')
                    .then(response => response.json())
                    .then(response => {
                        const billingAddr = response.find(address=> address.type==="1" || address.type==="3");
                        // type='3' is the combined billing+shipping record written when
                        // is_same_address=1 (magazine flow uses this path). Fall back to it
                        // for shipping when no dedicated type='2' record exists.
                        const shippingAddr = response.find(address=> address.type==="2") || response.find(address=> address.type==="3");
                        this.setState({
                            getOrderBillingAddress: billingAddr ? [billingAddr] : [],
                            getOrderShippingAddress: shippingAddr ? [shippingAddr] : []
                        });
                        // FIX: Supplement missing city/state/country names from user profile
                        if (billingAddr && (!billingAddr.city_name || !billingAddr.state_name || !billingAddr.country_name)) {
                            fetch(myConstClass.BASE_URL + 'users/getBillingAddress/1/' + loggedInUserId)
                                .then(res => res.json())
                                .then(userAddr => {
                                    if (userAddr && userAddr.length > 0) {
                                        const profileAddr = userAddr[0];
                                        const supplemented = {
                                            ...billingAddr,
                                            city_name: billingAddr.city_name || profileAddr.city_name || '',
                                            state_name: billingAddr.state_name || profileAddr.state_name || '',
                                            country_name: billingAddr.country_name || profileAddr.country_name || ''
                                        };
                                        this.setState({ getOrderBillingAddress: [supplemented] });
                                    }
                                }).catch(() => {});
                        }
                    }).catch(() => {});
            }
        }
        
        // If guest user and coming from payment success, complete order but don't redirect
        if (isGuestAutoCreated === 'true' && orderId && successMessage && successMessage.includes('completed successfully')) {
            // First, load and display order details immediately from pending order
            const pendingOrder = JSON.parse(localStorage.getItem('pending_guest_order') || 'null');
            if (pendingOrder) {
                // Format pending order for display
                const formattedOrder = {
                    order_id: pendingOrder.order_id || orderId,
                    order_id_main: pendingOrder.order_id_main || orderId,
                    transaction_id: pendingOrder.transaction_id || 'PROCESSING',
                    status: pendingOrder.status || 'Success',
                    total_price: pendingOrder.total_price || '0',
                    shipping_charges: pendingOrder.shipping_charges || '0',
                    created_on: pendingOrder.created_on || new Date().toISOString(),
                    payment_mode: pendingOrder.payment_mode || 'Online',
                    delivery_type: pendingOrder.delivery_type || '1'
                };
                
                // Set state immediately for display
                this.setState({ 
                    detailsarray: [formattedOrder],
                    productitem: pendingOrder.products || [],
                    magazineitem: pendingOrder.magazines || [],
                    eventitem: pendingOrder.events || [],
                    eventTestitem: pendingOrder.machineTestEvents || [],
                    getOrderBillingAddress: [pendingOrder.billing_address] || {},
                    getOrderShippingAddress: [pendingOrder.shipping_address] || {}
                });
                
                this.setState({
                    eventinfo: {
                        ...this.state.eventinfo,
                        transaction_id: pendingOrder.transaction_id || 'PROCESSING',
                        order_id_main: pendingOrder.order_id_main || orderId,
                        status: pendingOrder.status || 'Success',
                        total_price: pendingOrder.total_price || '0',
                        created_on: pendingOrder.created_on || new Date().toISOString(),
                        order_id: pendingOrder.order_id || orderId
                    }
                });
                
                this.setState({ orderDisplayStatus: 'success' });
                
                // CRITICAL FIX: Fetch event data with WhatsApp links AFTER page fully loads
                // Use setTimeout to ensure the page is completely rendered before making API calls
                // This prevents API calls from being cancelled during component mount
                
                setTimeout(() => {
                    
                    // Retry mechanism with increasing delays for fresh orders that might not be synced yet
                    const tryFetchWithRetry = (attempt = 1, maxAttempts = 3) => {
                        return this.fetchEventOrderFromNode(orderId).then(success => {
                            if (success) {
                                return true;
                            } else if (attempt < maxAttempts) {
                                return new Promise(resolve => {
                                    setTimeout(() => {
                                        resolve(tryFetchWithRetry(attempt + 1, maxAttempts));
                                    }, attempt * 2000); // Increasing delay: 2s, 4s, 6s
                                });
                            } else {
                                return false;
                            }
                        }).catch(err => {
                            if (attempt < maxAttempts) {
                                return new Promise(resolve => {
                                    setTimeout(() => {
                                        resolve(tryFetchWithRetry(attempt + 1, maxAttempts));
                                    }, attempt * 2000);
                                });
                            }
                            return false;
                        });
                    };
                    
                    // Start fetching event data after page is fully loaded
                    tryFetchWithRetry();
                    
                    // Also use fetchGuestOrderFromPHP for complete order data (products + events)
                    this.fetchGuestOrderFromPHP(orderId, pendingOrder);
                }, 1000); // Wait 1 second for page to fully render before making API calls
                
                // Now complete the order in the background (this can run in parallel)
                const paymentResponse = {
                    order_id: orderId,
                    transaction_id: 'SUCCESS',
                    order_status: 'Success',
                    payment_mode: 'Online'
                };
                
                completePendingGuestOrder(paymentResponse).then(() => {
                    // After event data is loaded, update order details (but NOT event items)
                    const completedOrder = getGuestOrderById(orderId);
                    if (completedOrder) {
                        const updatedFormattedOrder = {
                            order_id: completedOrder.order_id,
                            order_id_main: completedOrder.order_id_main,
                            transaction_id: completedOrder.transaction_id,
                            status: completedOrder.status,
                            total_price: completedOrder.total_price,
                            shipping_charges: completedOrder.shipping_charges || '0',
                            created_on: completedOrder.created_on,
                            payment_mode: completedOrder.payment_mode,
                            delivery_type: completedOrder.delivery_type
                        };
                        
                        // Update order details and non-event items ONLY
                        // DO NOT overwrite eventitem/eventTestitem - they have WhatsApp links from API!
                        this.setState({ 
                            detailsarray: [updatedFormattedOrder],
                            productitem: completedOrder.products || [],
                            magazineitem: completedOrder.magazines || [],
                            // DON'T update eventitem/eventTestitem here - preserve API data with WhatsApp links
                            getOrderBillingAddress: [completedOrder.billing_address] || {},
                            getOrderShippingAddress: [completedOrder.shipping_address] || {}
                        });
                        
                        this.setState({
                            eventinfo: {
                                ...this.state.eventinfo,
                                transaction_id: completedOrder.transaction_id,
                                order_id_main: completedOrder.order_id_main,
                                status: completedOrder.status,
                                total_price: completedOrder.total_price,
                                created_on: completedOrder.created_on,
                                order_id: completedOrder.order_id
                            }
                        });
                    }
                    
                    // Clear guest cart and address data after order is finalized
                    localStorage.removeItem('guest_cart_products');
                    localStorage.removeItem('guest_cart_magazines');
                    localStorage.removeItem('guest_cart_events');
                    localStorage.removeItem('guest_billing_address');
                    localStorage.removeItem('guest_shipping_address');
                    localStorage.removeItem('temp_guest_user_id');
                    localStorage.removeItem('booking_event');
                    localStorage.removeItem('booking_event_guest');
                    localStorage.removeItem('guest_event_participants');
                    localStorage.setItem('cartCount', 0);
                    
                    // Clear guest session flags AFTER everything is loaded
                    localStorage.removeItem('isGuestAutoCreated');
                    localStorage.removeItem('guest_user_id_temp');
                    localStorage.removeItem('guest_email');
                    localStorage.removeItem('guest_first_name');
                }).catch(error => {
                    // Clear flags anyway
                    localStorage.removeItem('isGuestAutoCreated');
                    localStorage.removeItem('guest_user_id_temp');
                    localStorage.removeItem('guest_email');
                    localStorage.removeItem('guest_first_name');
                });
            } else {
                (!(localStorage.getItem('continue_as_guest') || localStorage.getItem('isGuestAutoCreated')) && toast('Order details could not be loaded', { containerId: 'B', type: toast.TYPE.ERROR }));
            }
            
            // IMPORTANT: Don't return early - continue to normal flow below
            // This allows the component to fetch complete order data with WhatsApp links
            // Fall through to the normal order loading logic (lines 783+)
        }
        
        var message = localStorage.getItem('success');
        if (message != '' && message != null) {
            toast('' + message, { containerId: 'B', type: toast.TYPE.SUCCESS });

            localStorage.removeItem('success');
        }

        var error = localStorage.getItem('error');
        if (error != '' && error != null) {
            toast('' + error, { containerId: 'B', type: toast.TYPE.ERROR });
            localStorage.removeItem('error');
        }
        
        if (answer_array['2'] > 0) {

        } else {
            //alert('hihere');
            //this.props.history.push('/order-list');
        }
        //alert(answer_array['3']);
        if (answer_array['3'] != '' && answer_array['3'] != undefined) {
            var message = answer_array['3'];
            if (message == 'Your Order has failed' || message.toLowerCase().includes('fail')) {
                this.setState({ orderDisplayStatus: 'failed' });
                toast('' + message, { containerId: 'B', type: toast.TYPE.ERROR });
            } else if (message.toLowerCase().includes('cancel')) {
                this.setState({ orderDisplayStatus: 'cancelled' });
                toast('' + message, { containerId: 'B', type: toast.TYPE.ERROR });
            } else {
                toast('' + message, { containerId: 'B', type: toast.TYPE.SUCCESS });
            }

        }

        if (answer_array['2']) {
            //alert(answer_array['2']);
            this.user_id = answer_array['2'];
            this.shouldHide = 1;
            
            // Check if user is logged in
            const user_id = localStorage.getItem('user_id');
            
            if (!user_id || user_id == 0) {
                // GUEST USER: First show from localStorage for immediate display, then fetch from server for canonical data
                const guestOrder = getGuestOrderById(answer_array['2']);
                
                if (guestOrder) {
                    
                    // Format order to match backend structure
                    const formattedOrder = {
                        order_id: guestOrder.order_id,
                        order_id_main: guestOrder.order_id_main,
                        transaction_id: guestOrder.transaction_id,
                        status: guestOrder.status,
                        total_price: guestOrder.total_price,
                        created_on: guestOrder.created_on,
                        payment_mode: guestOrder.payment_mode,
                        delivery_type: guestOrder.delivery_type
                    };
                    
                    // Set state immediately for fast display
                    this.setState({ 
                        detailsarray: [formattedOrder],
                        productitem: guestOrder.products || [],
                        magazineitem: guestOrder.magazines || [],
                        eventitem: guestOrder.events || [],
                        eventTestitem: guestOrder.machineTestEvents || [],
                        getOrderBillingAddress: [guestOrder.billing_address] || [],
                        getOrderShippingAddress: [guestOrder.shipping_address] || []
                    });
                    
                    this.setState({
                        eventinfo: {
                            ...this.state.eventinfo,
                            transaction_id: guestOrder.transaction_id,
                            order_id_main: guestOrder.order_id_main,
                            status: guestOrder.status,
                            total_price: guestOrder.total_price,
                            created_on: guestOrder.created_on,
                            order_id: guestOrder.order_id
                        }
                    });
                    
                    this.setState({ orderDisplayStatus: 'success' });
                }
                
                // NOW FETCH CANONICAL DATA FROM SERVER
                // DUAL SYSTEM: Events use Node.js API, Products use PHP API
                const bookingId = guestOrder?.booking_id || localStorage.getItem('last_booking_id');
                
                if (bookingId) {
                    // EVENT BOOKING: Try Node.js booking API first (events are handled by Node.js)
                    fetch(`${myConstClass.NODE_API_BASE}/booking/getBookingDetails/${bookingId}`)
                        .then(response => response.json())
                        .then(result => {
                            if (result.status === 'true' || result.status === true) {
                                const bookingData = result.data;
                                
                                // Update state with canonical server data
                                const serverOrder = {
                                    order_id: bookingData.bookingId || bookingData.booking_id,
                                    order_id_main: bookingData.bookingId || bookingData.booking_id,
                                    transaction_id: bookingData.transactionId || bookingData.transaction_id || 'PENDING',
                                    status: bookingData.status || 'Pending',
                                    total_price: bookingData.totalAmount || bookingData.total_amount || '0',
                                    created_on: bookingData.createdAt || bookingData.created_at,
                                    payment_mode: 'Online',
                                    delivery_type: '1'
                                };
                                
                                this.setState({
                                    detailsarray: [serverOrder],
                                    eventinfo: {
                                        ...this.state.eventinfo,
                                        transaction_id: serverOrder.transaction_id,
                                        order_id_main: serverOrder.order_id_main,
                                        status: serverOrder.status,
                                        total_price: serverOrder.total_price,
                                        created_on: serverOrder.created_on,
                                        order_id: serverOrder.order_id
                                    }
                                });
                            } else {
                                // Fallback to PHP payment API
                                this.fetchGuestOrderFromPHP(answer_array['2'], guestOrder);
                            }
                        })
                        .catch(err => {
                            // Fallback to PHP payment API for products
                            this.fetchGuestOrderFromPHP(answer_array['2'], guestOrder);
                        });
                } else {
                    // PRODUCT ORDER: Use PHP payment API (products are handled by PHP)
                    this.fetchGuestOrderFromPHP(answer_array['2'], guestOrder);
                }
                
                // Only fetch event data from Node.js API if this is an event order (bookingId present).
                // For product orders (no bookingId), calling fetchEventOrderFromNode can return
                // unrelated old Node.js event data when orderId numerically matches a different event.
                if (bookingId) {
                    this.fetchEventOrderFromNode(answer_array['2']).catch(() => {});
                }
                
                return; // Don't continue to logged-in user flow
            }
            
            // Logged-in user: Determine order type and fetch from appropriate API
            // FIX: Check PHP API FIRST to avoid order ID collisions with Node.js event orders.
            // Product/cart orders exist in PHP DB. Event booking orders exist in Node.js DB.
            // Since both use auto-incrementing IDs, the same numeric order_id can refer to
            // completely different orders in each system. Checking PHP first ensures product
            // orders are handled correctly without picking up unrelated event data from Node.js.
            const orderId = answer_array['2'];
            const userId = localStorage.getItem('user_id');
            
            // Step 1: Check PHP API first (for products, magazines, machine tests, PHP-based events)
            fetch(myConstClass.BASE_URL + 'payment/getOrderDetails/' + orderId + '/' + getLanguage(), {
                cache: 'no-cache'
            })
                .then(response => response.json())
                .then(response => {
                    if(response && response[0] && response[0].user_id_fk == userId){
                    // Order found in PHP DB - use PHP flow for all items
                    const orderType = response[0].order_type;
                    
                    this.setState({ detailsarray: response })
                    this.setState({
                        eventinfo: {
                            ...this.state.eventinfo,
                            transaction_id: response[0].transaction_id,
                            order_id_main: response[0].order_id_main
                        }
                    })

                    var status = response[0].status;

                    if (status == 'Dispatched' || status == 'Confirm') {
                        $('#cancelOrderButton').css('display', 'block');
                    } else {
                        $('#cancelOrderButton').css('display', 'none');
                    }

                    if (status == 'Pending') {
                        this.setState({ orderDisplayStatus: 'failed' });
                    } else if (status == 'Cancelled') {
                        this.setState({ orderDisplayStatus: 'cancelled' });
                    } else {
                        this.setState({ orderDisplayStatus: 'success' });
                    }

                    // Send order confirmation email to guest users
                    const isGuestAutoCreated = localStorage.getItem('isGuestAutoCreated') === 'true';
                    if (isGuestAutoCreated && status == 'Confirm') {
                        const userEmail = localStorage.getItem('guest_email');
                        const firstName = localStorage.getItem('guest_first_name');
                        const userId = localStorage.getItem('guest_user_id_temp');
                        const orderIdMain = response[0].order_id_main;

                        sendGuestOrderConfirmationEmail({
                            email: userEmail,
                            orderIdMain: orderIdMain,
                            firstName: firstName,
                            userId: userId
                        }).then(result => {
                            if (result.success) {
                                localStorage.removeItem('isGuestAutoCreated');
                                localStorage.removeItem('guest_user_id_temp');
                                localStorage.removeItem('guest_email');
                                localStorage.removeItem('guest_first_name');
                            }
                        });
                    }
                    
                    // Fetch order items based on order type.
                    // PHP getOrderDetails returns order_type as '1' when any item is a product
                    // (is_product_event='1'), and '2' otherwise. Without '1' here, a Product+MT
                    // order skipped this whole block and eventTestitem stayed empty while the
                    // unconditional early-fetch above had already populated productitem.
                    if (orderType === 'product' || orderType === 'magazine' || orderType === 'mixed' || orderType === '1' || orderType === '2' || !orderType) {

                        fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsItem/' + orderId + '/' + getLanguage())
                            .then(r => r.json()).then(r => {
                                this.setState({ productitem: r || [] });
                            })
                            .catch(() => {});
                        
                        fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsMagazineItem/' + orderId + '/' + getLanguage())
                            .then(r => r.json()).then(r => {
                                this.setState({ magazineitem: r || [] });
                            })
                            .catch(() => {});
                        
                        fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsMachineTestEventItem/' + orderId + '/' + getLanguage())
                            .then(r => r.json()).then(r => {
                                this.setState({ eventTestitem: r || [] });
                            })
                            .catch(() => {
                                this.setState({ eventTestitem: [] });
                            });
                        
                        fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsEventItem/' + orderId + '/' + getLanguage())
                            .then(r => r.json()).then(r => {
                                this.setState({ eventitem: r || [] });
                            })
                            .catch(() => {});
                        
                        fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + orderId + '/1')
                            .then(r => r.json()).then(r => {
                                // When is_same_address=1 (common in magazine flow), backend stores
                                // a single order_address row with type='3' representing both
                                // billing and shipping. Treat type='3' as a valid shipping match
                                // too — otherwise shipping column renders empty for magazines.
                                const billingAddr = r.find(a => a.type === "1" || a.type === "3");
                                const shippingAddr = r.find(a => a.type === "2") || r.find(a => a.type === "3");
                                this.setState({
                                    getOrderBillingAddress: billingAddr ? [billingAddr] : [],
                                    getOrderShippingAddress: shippingAddr ? [shippingAddr] : []
                                });
                                // FIX: For machine-test-only orders, the PHP backend saves wrong column
                                // references for city/state/country IDs, causing JOINs to return NULL names.
                                // Supplement missing names from the user's profile billing address.
                                if (billingAddr && (!billingAddr.city_name || !billingAddr.state_name || !billingAddr.country_name)) {
                                    fetch(myConstClass.BASE_URL + 'users/getBillingAddress/1/' + userId)
                                        .then(res => res.json())
                                        .then(userAddr => {
                                            if (userAddr && userAddr.length > 0) {
                                                const profileAddr = userAddr[0];
                                                const supplemented = {
                                                    ...billingAddr,
                                                    city_name: billingAddr.city_name || profileAddr.city_name || '',
                                                    state_name: billingAddr.state_name || profileAddr.state_name || '',
                                                    country_name: billingAddr.country_name || profileAddr.country_name || ''
                                                };
                                                this.setState({ getOrderBillingAddress: [supplemented] });
                                            }
                                        }).catch(() => {});
                                }
                            }).catch(() => {});
                    }
                } else{
                    // Order NOT found in PHP DB - try Node.js API (for normal event bookings)
                    this.fetchNodeOrderDetails(orderId, {
                        cache: 'no-cache'
                    })
                        .then(result => {
                            if (result.status === 'true' && result.data && result.data.order) {
                                const { order } = result.data;
                                
                                if (order.user_id_fk == userId) {
                                    return this.fetchEventOrderFromNode(orderId).then(success => {
                                        if (success) {
                                            const mappedStatus = this.mapOrderStatus(order.status);
                                            
                                            if (mappedStatus == 'Dispatched' || mappedStatus == 'Confirm') {
                                                $('#cancelOrderButton').css('display', 'block');
                                            } else {
                                                $('#cancelOrderButton').css('display', 'none');
                                            }

                                            // Respect URL-based status (from payment gateway redirect) over Node.js DB status.
                                            // The payment gateway redirect URL is the authoritative source for payment outcome.
                                            // The Node.js order status may not yet reflect failure (order was created before payment).
                                            if (successMessage && successMessage.toLowerCase().includes('fail')) {
                                                this.setState({ orderDisplayStatus: 'failed' });
                                            } else if (successMessage && successMessage.toLowerCase().includes('cancel')) {
                                                this.setState({ orderDisplayStatus: 'cancelled' });
                                            } else if (mappedStatus == 'Pending') {
                                                this.setState({ orderDisplayStatus: 'failed' });
                                            } else if (mappedStatus == 'Cancelled') {
                                                this.setState({ orderDisplayStatus: 'cancelled' });
                                            } else {
                                                this.setState({ orderDisplayStatus: 'success' });
                                            }
                                            
                                            return true;
                                        } else {
                                            throw new Error('Failed to load event data');
                                        }
                                    });
                                } else {
                                    throw new Error('User does not own this order');
                                }
                            } else {
                                throw new Error('Not an event order');
                            }
                        })
                        .catch(err => {
                            toast('Unable to load order details', { containerId: 'B', type: toast.TYPE.ERROR });
                            this.setState({
                                detailsarray: [{ error: true, message: 'Unable to load order details' }],
                                productitem: [],
                                magazineitem: [],
                                eventitem: [],
                                eventTestitem: []
                            });
                            this.setState({ orderDisplayStatus: 'failed' });
                        });
                }

                })
                .catch(err => {
                    toast('Failed to load order details', { containerId: 'B', type: toast.TYPE.ERROR });
                    this.setState({
                        detailsarray: [{ error: true, message: 'Failed to load order details' }],
                        productitem: [],
                        magazineitem: [],
                        eventitem: [],
                        eventTestitem: []
                    });
                });

            // fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + answer_array['2'] + '/2')
            //     .then(response => response.json())
            //     .then(response => {
            //         this.setState({ getOrderShippingAddress: response })

            //     })


            //     .catch(err => console.log(err))


        }
        // this.getCountry();
        // this.getEvent();

    }

    componentDidUpdate(prevProps) {
        const { flag } = this.state
        const answer_array = this.props.location.pathname.split('/');
        var current_language = localStorage.getItem('current_language');
        if (current_language !== getLanguage() && flag !== 1 && current_language !== null) {
            //alert(current_language);
            localStorage.removeItem('current_language');
            localStorage.setItem('current_language', getLanguage());
            this.setState({ flag: 1 });
        }
        if (getLanguage() === 'ma' && flag === 1) {
            this.setState({ flag: 0 })

            const answer_array = this.props.location.pathname.split('/');

            if (answer_array['2']) {
                //alert(answer_array['2']);
                this.user_id = answer_array['2'];
                this.shouldHide = 1;
                fetch(myConstClass.BASE_URL + 'payment/getOrderDetails/' + answer_array['2'] + '/' + getLanguage(), {
                    cache: 'no-cache'
                })
                    .then(response => response.json())
                    .then(response => {
                        if (!response || !response[0]) return;
                        
                        const orderType = response[0].order_type;
                        this.setState({ detailsarray: response })
                        this.state.eventinfo.transaction_id = this.state.detailsarray[0].transaction_id;
                        this.state.eventinfo.order_id_main = this.state.detailsarray[0].order_id_main;
                        var status = response[0].status;
                        //alert(status);

                        if (status == 'Dispatched' || status == 'Confirm') {
                            $('#cancelOrderButton').css('display', 'block');
                        } else {
                            $('#cancelOrderButton').css('display', 'none');
                        }

                        if (status == 'Pending') {
                            this.setState({ orderDisplayStatus: 'failed' });
                        } else if (status == 'Cancelled') {
                            this.setState({ orderDisplayStatus: 'cancelled' });
                        } else {
                            this.setState({ orderDisplayStatus: 'success' });
                        }
                        
                        // Fetch items based on order type
                        if (orderType === 'event' || orderType === 'mixed') {
                            this.fetchEventOrderFromNode(answer_array['2']);
                        }
                        
                        if (orderType === 'product' || orderType === 'magazine' || orderType === 'mixed' || !orderType) {
                            fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsItem/' + answer_array['2'] + '/' + getLanguage(), {cache: 'no-cache'})
                                .then(response => response.json())
                                .then(response => {
                                    this.setState({ productitem: response })
                                })

                            fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsMagazineItem/' + answer_array['2'] + '/' + getLanguage(), {cache: 'no-cache'})
                                .then(response => response.json())
                                .then(response => {
                                    this.setState({ magazineitem: response })
                                })

                            fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + answer_array['2'] + '/1', {cache: 'no-cache'})
                                .then(response => response.json())
                                .then(response => {
                                    // Same is_same_address=1 → type='3' fallback as the main flow.
                                    const billingAddr = response.find(address=> address.type==="1" || address.type==="3");
                                    const shippingAddr = response.find(address=> address.type==="2") || response.find(address=> address.type==="3");
                                    this.setState({
                                        getOrderBillingAddress: billingAddr ? [billingAddr] : [],
                                        getOrderShippingAddress: shippingAddr ? [shippingAddr] : []
                                    })
                                })
                        }

                    })

                // fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + answer_array['2'] + '/2')
                //     .then(response => response.json())
                //     .then(response => {
                //         this.setState({ getOrderShippingAddress: response })

                //     })

                //     .catch(err => console.log(err))
            }

        }
        if (getLanguage() == 'en' && (flag == 1)) {
            this.setState({ flag: 0 })

            const answer_array = this.props.location.pathname.split('/');

            if (answer_array['2']) {
                //alert(answer_array['2']);
                this.user_id = answer_array['2'];
                this.shouldHide = 1;
                fetch(myConstClass.BASE_URL + 'payment/getOrderDetails/' + answer_array['2'] + '/' + getLanguage(), {
                    cache: 'no-cache'
                })
                    .then(response => response.json())
                    .then(response => {
                        if (!response || !response[0]) return;
                        
                        const orderType = response[0].order_type;
                        this.setState({ detailsarray: response })
                        this.state.eventinfo.transaction_id = this.state.detailsarray[0].transaction_id;
                        this.state.eventinfo.order_id_main = this.state.detailsarray[0].order_id_main;
                        var status = response[0].status;
                        //alert(status);

                        if (status == 'Dispatched' || status == 'Confirm') {
                            $('#cancelOrderButton').css('display', 'block');
                        } else {
                            $('#cancelOrderButton').css('display', 'none');
                        }

                        if (status == 'Pending') {
                            this.setState({ orderDisplayStatus: 'failed' });
                        } else if (status == 'Cancelled') {
                            this.setState({ orderDisplayStatus: 'cancelled' });
                        } else {
                            this.setState({ orderDisplayStatus: 'success' });
                        }
                        
                        // Fetch items based on order type
                        if (orderType === 'event' || orderType === 'mixed') {
                            this.fetchEventOrderFromNode(answer_array['2']);
                        }
                        
                        if (orderType === 'product' || orderType === 'magazine' || orderType === 'mixed' || !orderType) {
                            fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsItem/' + answer_array['2'] + '/' + getLanguage(), {cache: 'no-cache'})
                                .then(response => response.json())
                                .then(response => {
                                    this.setState({ productitem: response })
                                })

                            fetch(myConstClass.BASE_URL + 'payment/getOrderDetailsMagazineItem/' + answer_array['2'] + '/' + getLanguage(), {cache: 'no-cache'})
                                .then(response => response.json())
                                .then(response => {
                                    this.setState({ magazineitem: response })
                                })

                            fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + answer_array['2'] + '/1', {cache: 'no-cache'})
                                .then(response => response.json())
                                .then(response => {
                                    // Same is_same_address=1 → type='3' fallback as the main flow.
                                    const billingAddr = response.find(address=> address.type==="1" || address.type==="3");
                                    const shippingAddr = response.find(address=> address.type==="2") || response.find(address=> address.type==="3");
                                    this.setState({
                                        getOrderBillingAddress: billingAddr ? [billingAddr] : [],
                                        getOrderShippingAddress: shippingAddr ? [shippingAddr] : []
                                    })
                                })
                        }

                    })

                    

                // fetch(myConstClass.BASE_URL + 'payment/getOrderBillingAddressBackend/' + answer_array['2'] + '/2')
                //     .then(response => response.json())
                //     .then(response => {
                //         this.setState({ getOrderShippingAddress: response })

                //     })

                //     .catch(err => console.log(err))
            }

        }


    }

    componentWillUnmount() {
        // Clear guest session and order info when leaving Orderdetails page
        localStorage.removeItem('guest_cart_products');
        localStorage.removeItem('guest_cart_magazines');
        localStorage.removeItem('guest_cart_events');
        localStorage.removeItem('guest_billing_address');
        localStorage.removeItem('guest_shipping_address');
        localStorage.removeItem('temp_guest_user_id');
        localStorage.removeItem('isGuestAutoCreated');
        localStorage.removeItem('guest_user_id_temp');
        localStorage.removeItem('guest_email');
        localStorage.removeItem('guest_first_name');
        localStorage.removeItem('pending_guest_order');
        localStorage.removeItem('guest_orders');
        // Clear booking_event data
        localStorage.removeItem('booking_event');
        localStorage.removeItem('booking_event_guest');
        localStorage.removeItem('guest_event_participants');
        localStorage.removeItem('event_checkout_in_progress');
        localStorage.setItem('cartCount', 0);
        localStorage.removeItem('cart_total_price');
        localStorage.removeItem('continue_as_guest');
        localStorage.removeItem('last_displayed_order_id');

    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }


    cancelOrder() {
        $('#cancelOrderModal').modal('show');
    }

    cancelOrderConfirm() {
        var user_id = localStorage.getItem('user_id');
        const answer_array = this.props.location.pathname.split('/');
        if (answer_array['2'] > 0 && user_id > 0) {
            //alert(answer_array['2']);

            fetch(myConstClass.BASE_URL + 'payment/cancelOrder/' + answer_array['2'] + '/' + user_id + '/3')
                .then(response => response.json())
                .then(response => {
                    this.setState({ cancelinfo: response })
                    var message = this.state.cancelinfo.message;
                    var status = this.state.cancelinfo.status;
                    $('#cancelOrderButton').css('display', 'none');
                    if (status == 'true') {
                        $('#cancelOrderModal').modal('hide');

                        toast('' + message, { containerId: 'B', type: toast.TYPE.SUCCESS });
                    } else {
                        toast('' + message, { containerId: 'B', type: toast.TYPE.ERROR });
                    }
                })

                .catch(() => {})


        }

    }

    render() {

        const { eventTestitem, eventitem, getOrderBillingAddress, getOrderShippingAddress, productitem, magazineitem, detailsarray, event, posts, guestinfo, cart, eventinfo, orderDisplayStatus, isGuestUser } = this.state
        const { t } = this.props;
        const allEvents = [ ...(eventTestitem || []), ...(eventitem || []) ];
        const isNormalEventOnly = eventitem.length > 0 && eventTestitem.length === 0 && productitem.length === 0 && magazineitem.length === 0;
        return (

            <div className="App">
                <div>
                    {/* <button onClick={this.notify}>Notify !</button> */}
                    <ToastContainer />
                </div>
                <NewHeader />
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row mt-5 m-xl-0 mt-lg-0 mt-md-4 mt-sm-5">
                                {!isGuestUser && (
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb bg-white mb-0">
                                        <li class="breadcrumb-item">
                                            <Link to="/">{t('home.home')}</Link>
                                        </li>
                                        <li class="breadcrumb-item">
                                            <Link to="/order-history">{t('home.Order History')}</Link>

                                        </li>
                                        <li class="breadcrumb-item active" aria-current="page">{t('home.Order ID')} {eventinfo.order_id_main} </li>
                                    </ol>
                                </nav>)}
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h5 style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
                                        <span style={{ display: orderDisplayStatus === 'success' ? '' : 'none' }}>
                                            {t('home.THANK YOU FOR ORDERING')}
                                        </span>
                                        <span style={{ display: orderDisplayStatus !== 'success' ? '' : 'none' }}>
                                            {t('home.SOMETHING WENT WRONG')}
                                        </span>
                                        <br />
                                        <div style={{ display: orderDisplayStatus === 'success' ? '' : 'none' }} id="scuccessOrder">
                                            <i style={{ fontSize: '25px', color: 'green', marginTop: '8px' }} class="fa fa-check-circle"></i>
                                            <span style={{ fontSize: '16px', marginLeft: '10px', marginTop: '8px', color: 'green' }}>{t('home.ORDER SUCCESSFUL')}</span>
                                        </div>
                                        <div style={{ display: orderDisplayStatus === 'failed' ? 'block' : 'none' }} id="scuccessFail">
                                            {/* <i style={{fontSize:'25px',color:'red',marginTop:'8px'}} class="fa fa-clock-o" aria-hidden="true"></i> */}
                                            <i class="fas fa-ban" style={{ fontSize: '25px', color: 'red', marginTop: '8px' }}></i>
                                            <span style={{ fontSize: '16px', marginLeft: '10px', marginTop: '8px', color: 'red' }}>{t('home.ORDER FAILED')}</span>
                                        </div>

                                        <div style={{ display: orderDisplayStatus === 'cancelled' ? 'block' : 'none' }} id="scuccessCancelled">
                                            {/* <i style={{fontSize:'25px',color:'red',marginTop:'8px'}} class="fa fa-clock-o" aria-hidden="true"></i> */}
                                            <i class="fas fa-ban" style={{ fontSize: '25px', color: 'red', marginTop: '8px' }}></i>
                                            <span style={{ fontSize: '16px', marginLeft: '10px', marginTop: '8px', color: 'red' }}>{t('home.ORDER CANCELLED')}</span>
                                        </div>
                                    </h5>

                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-12">
                                    <p >
                                        <span style={{ display: orderDisplayStatus === 'success' ? '' : 'none' }}>  {t('home.Your order is successful')}.</span>
                                        <span style={{ display: orderDisplayStatus === 'failed' ? 'inline' : 'none' }}>{t('home.Your order is failed')}.</span>
                                        <span style={{ display: orderDisplayStatus === 'cancelled' ? 'inline' : 'none' }}>{t('home.Your order is cancelled')}.</span>
                       &nbsp;<strong>{t('home.Your order number is ')}&nbsp;{eventinfo.order_id_main}.</strong>
                                        <br />
                                        {t('home.You will receive following two email confirmations on your email id')} 
                                        <br />
                        1.{t('home.From CCAvenue (E-commerce Payment Gateway)')}
                                        <br />
                        2.{t('home.From Manashakti Research Center,Lonavla')}
                                        <br />
                        3.{t('home.you will receive sms')}
                                        <br />
                        {isGuestUser ? t('4. From Manashakti Research Center for registration') : t('')}
                                    </p>
                                        {/* WhatsApp group links for booked event schedules (if available).
                                            Render only when there are booked events (normal or machine-test).
                                            Do not show for product/magazine-only orders. */}
                                        {allEvents.length > 0 && (
                                            <div style={{ marginTop: '8px' }}>
                                                {allEvents.map((ev, idx) => {
                                                    // Use whatsapp_link directly from event item
                                                    const url = ev.whatsapp_link;

                                                    if (url) {
                                                        return (
                                                            <div key={"whatsapp-" + idx} style={{ marginTop: '6px' }}>
                                                                <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-sm">
                                                                    {this.translateOr('home.Join WhatsApp Group','Join WhatsApp Group')}
                                                                </a>
                                                            </div>
                                                        );
                                                    }

                                                    // Don't show anything if WhatsApp link is not available
                                                    return null;
                                                })}
                                            </div>
                                        )}
                                    <p>
                                        {t('home.To continue browsing')}.
                                    <Link to={'/'} style={{ textDecoration: 'underline' }}>{t('home.Return to Home Page')}</Link>

                                    </p>

                                </div>
                            </div>
                        {!isGuestUser?(<div>
                            <div class="row">
                                <div class="col-12">
                                    <h5>{t('home.Order ID')} {eventinfo.order_id_main}</h5>
                                </div>
                            </div>

                            {/* Desktop Design */}
                            <div className="d-xl-block d-lg-block d-md-block d-none">
                                <div class="row">
                                    <div class="col">
                                        {/* Check if order has error */}
                                        {detailsarray.length > 0 && detailsarray[0].error ? (
                                            <div className="alert alert-warning" role="alert">
                                                <h4 className="alert-heading">⚠️ {detailsarray[0].message}</h4>
                                                <p>
                                                    We couldn't find the order details you're looking for. 
                                                    {detailsarray[0].order_id && (
                                                        <p><strong>Order ID:</strong> {detailsarray[0].order_id}</p>
                                                    )}
                                                </p>
                                            </div>
                                        ) : (
                                        <table class="table bg-light">
                                            <tr>
                                                <th>{t('home.Placed On')}</th>
                                                <th>{t('home.Order ID')}</th>
                                                {/* <th>Expected Date of <br/>Product Deilvery</th> */}
                                                <th>{t('home.Expected Date of Product Delivery')}</th>
                                                <th>{t('home.Status')}</th>
                                                <th>{t('home.Courier Traking URL')}</th>
                                                {/* <th>Courier Tracking URL</th> */}
                                                {/* <th>Courier Tracking ID</th> */}
                                                <th>{t('home.Donation Contribution')}</th>
                                                <th>{t('home.Shipping Charges')}</th>
                                                <th>{t('home.Billing Details')}</th>
                                                <th>{t('home.Shipping Details')}</th>
                                            </tr>
                                            {detailsarray.map((info, ii) => {
                                                if (info.courier_url_available == 1) {
                                                    return (
                                                        <tr>
                                                            <td>{info.order_type === 'event' ? this.formatDateOnly(info.created_on) : info.created_on}</td>
                                                            <td>{info.order_id_main}</td>
                                                            <td>{info.courier_date_format}</td>
                                                            <td>
                                                                {info.status}
                                                            </td>
                                                            <td><a target="_blank" href={info.courier_url}>{info.courier_url}</a> </td>

                                                            <td>{t('home.INR')} {info.total_price * 1}/-</td>
                                                            <td>{t('home.INR')} {info.shipping_charges}/-</td>

                                                            <td>
                                                                {getOrderBillingAddress.map((info, ii) => {
                                                                    return (
                                                                        <div >
                                                                            {info.company}<br />
                                                                            {info.address_line_1} <br />
                                                                            {info.address_line_2}<br />
                                                                            {info.landmark}<br />
                                                                            {info.city_name},{info.state_name}- &nbsp; {info.pincode}<br />
                                                                            {info.country_name}.<br />

                                                                            {t('home.Email')}: {info.email}<br />
                                                                            {t('home.Phone')}: {info.phone}<br />
                                                                        </div>
                                                                    )
                                                                })
                                                                }
                                                            </td>
                                                            <td>
                                                                {isNormalEventOnly ? 'NA' : getOrderShippingAddress.map((info, ii) => {
                                                                    return (
                                                                        <div >
                                                                        
                                                                            {info.company}<br />
                                                                            {info.address_line_1} <br />
                                                                            {info.address_line_2}<br />
                                                                            {info.landmark}<br />
                                                                            {info.city_name},{info.state_name}- &nbsp; {info.pincode}<br />
                                                                            {info.country_name}.<br />

                                                                            {t('home.Email')}: {info.email}<br />
                                                                            {t('home.Phone')}: {info.phone}<br />
                                                                        </div>
                                                                    )
                                                                })
                                                                }
                                                            </td>
                                                            <td>
                                                                {/* <button id="cancelOrderButton" onClick={this.cancelOrder} class="btn btn-outline-brown bg-white" style={{color:'black',display:'none'}}>{t('home.Cancel Order')}</button> */}
                                                            </td>
                                                        </tr>
                                                    )
                                                } else {
                                                        return (
                                                        <tr>
                                                            <td>{info.order_type === 'event' ? this.formatDateOnly(info.created_on) : info.created_on}</td>
                                                            <td>{info.order_id_main}</td>
                                                            <td>{info.order_type !== "2"?info.courier_date_format:'NA'}</td>
                                                            <td>
                                                                {info.status}
                                                            </td>
                                                            <td>
                                                                {info.order_type !== "2"?info.courier_url:'NA'}
                                                            </td>

                                                            <td>{t('home.INR')} {info.total_price * 1}/-</td>
                                                            <td>
                                                                {info.order_type !== "2"?t('home.INR')+' '+info.shipping_charges+' /-':'NA'}
                                                            </td>

                                                            <td>
                                                                {getOrderBillingAddress.map((info, ii) => {
                                                                    return (
                                                                        <div >

                                                                            {info.company}<br />
                                                                            {info.address_line_1} <br />
                                                                            {info.address_line_2}<br />
                                                                            {info.landmark}<br />
                                                                            {info.city_name},{info.state_name}- &nbsp; {info.pincode}<br />
                                                                            {info.country_name}.<br />

                                                                            {t('home.Email')}: {info.email}<br />
                                                                            {t('home.Phone')}: {info.phone}<br />
                                                                        </div>
                                                                    )
                                                                })
                                                                }
                                                            </td>
                                                            
                                                            <td>
                                                                {isNormalEventOnly ? 'NA' : getOrderShippingAddress.map((info, ii) => {
                                                                    return (
                                                                        <div >

                                                                            {info.company}<br />
                                                                            {info.address_line_1} <br />
                                                                            {info.address_line_2}<br />
                                                                            {info.landmark}<br />
                                                                            {info.city_name},{info.state_name}- &nbsp; {info.pincode}<br />
                                                                            {info.country_name}.<br />

                                                                            {t('home.Email')}: {info.email}<br />
                                                                            {t('home.Phone')}: {info.phone}<br />
                                                                        </div>
                                                                    )
                                                                })
                                                                }
                                                            </td>
                                                            <td>
                                                                {/* <button id="cancelOrderButton" onClick={this.cancelOrder} class="btn btn-outline-brown bg-white" style={{color:'black',display:'none'}}>{t('home.Cancel Order')}</button> */}
                                                            </td>
                                                        </tr>
                                                    )
                                                }

                                            })
                                            }
                                        </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        ):(
                            <div>
                                <h5 style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>{t('Please Register to view your order details')}</h5>
                                <div className="mt-3 d-flex justify-content-center" style={{ gap: '10px', maxWidth: '320px', margin: '0 auto' }}>
                                    <Link to="/signin" className="btn btn-brown w-100">
                                        {t('Login')}
                                    </Link>

                                    <Link to="/signup" className="btn btn-brown w-100">
                                        {t('Register')}
                                    </Link>
                                </div>

                            </div>
                        )}
                            {/* Mobile Design */}

                            {!isGuestUser ? <div className="d-xl-none d-lg-none d-md-none d-block mb-4">
                                {
                                    detailsarray.map(info =>

                                        <Card className="bg-light p-4">
                                            <Row>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Placed On')}&nbsp;:&nbsp;
                                                    </span>
                                                    {info.order_type === 'event' ? this.formatDateOnly(info.created_on) : info.created_on}
                                                </Col>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Order ID')}&nbsp;:&nbsp;
                                                    </span>
                                                    {info.order_id_main}
                                                </Col>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Status')}&nbsp;:&nbsp;
                                                    </span>
                                                    {info.status}
                                                </Col>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Courier Traking URL')}&nbsp;:&nbsp;
                                                    </span>
                                                    {info.courier_url_available == 1 ? <a target="_blank" href={info.courier_url}>{info.courier_url}</a> : info.courier_url}
                                                </Col>

                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Expected Date of Product Delivery')}&nbsp;:&nbsp;
                                                    </span>
                                                    {info.courier_date_format}
                                                </Col>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                                    </span>
                                                    {t('home.INR')} {info.total_price * 1}/-
                                                    </Col>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Shipping Charges')}&nbsp;:&nbsp;
                                                    </span>
                                                    {t('home.INR')} {info.shipping_charges}/-
                                                    </Col>
                                                <Col sm="12" xs="12">
                                                    <span className="font-weight-bold">
                                                        {t('home.Shipping Details')}&nbsp;:&nbsp;
                                                    </span>
                                                    {isNormalEventOnly ? 'NA' : getOrderShippingAddress.map((info, ii) => {
                                                        return (
                                                            <div >
                                                                {info.company}<br />
                                                                {info.address_line_1} <br />
                                                                {info.address_line_2}<br />
                                                                {info.landmark}<br />
                                                                {info.city_name},{info.state_name}- &nbsp; {info.pincode}<br />
                                                                {info.country_name}.<br />

                                                                {t('home.Email')}: {info.email}<br />
                                                                {t('home.Phone')}: {info.phone}<br />
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </Col>
                                            </Row>
                                        </Card>
                                    )
                                }
                            </div> : (
                                <div>
                                    {/* <h3>{t('home.Please Register to view your order details')}</h3> */}
                                </div>
                            )
                            }

                            {/* Desktop Design */}
                            {!isGuestUser ? (
                            <div className="d-xl-block d-lg-block d-md-block d-none">
                                <div class="row">
                                    <div class="col">
                                        <table class="table table-sm table-bordered" >
                                            <thead class="bg-light">
                                                <tr>
                                                    <th >{t('home.No')}</th>
                                                    <th scope="col-2">{t('home.Item')}</th>
                                                    <th scope="col-2">{t('home.Type')}</th>
                                                    <th scope="col-2">{t('home.Language')}</th>
                                                    <th scope="col-2">{t('home.Details')}</th>
                                                    <th scope="col">{t('home.Quantity')}</th>
                                                    <th scope="col">{t('home.No of Participants')}</th>
                                                    <th scope="col ">{t('home.donation_contribution')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>


                                                {eventTestitem.map((info, j) => {
                                                    return (
                                                        <tr>
                                                            <td>{j + 1}</td>
                                                            <td>

                                                                {info.title}
                                                                {/* Show participants if available */}
                                                                {info.participants && info.participants.length > 0 && (
                                                                    <div style={{ fontSize: '0.85em', marginTop: '8px', color: '#666' }}>
                                                                        <strong>Participants:</strong>
                                                                        <ul style={{ marginTop: '4px', paddingLeft: '20px', marginBottom: 0 }}>
                                                                            {info.participants.map((participant, idx) => (
                                                                                <li key={idx}>
                                                                                    {participant.first_name} {participant.last_name}
                                                                                    {participant.email && ` (${participant.email})`}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {t('home.Test')}:<br />
                                                                {info.event_type}</td>
                                                            <td>{info.event_language}</td>
                                                            <td>
                                                                {t('home.NA')}
                                                            </td>
                                                            <td>{t('home.NA')}</td>
                                                            <td>
                                                                {info.participants_count || (info.parent * 1 + info.child * 1)}
                                                                {/* {info.venue_address} */}
                                                            </td>

                                                            <td>
                                                                {t('home.INR')} {info.item_total || (info.price * info.parent + info.second_price * info.child)}
                                                            </td>
                                                        </tr>
                                                    )

                                                })
                                                }



                                                {eventitem.map((info, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{eventTestitem.length + i + 1}</td>
                                                            <td>

                                                                {info.title}
                                                                {/* Show participants if available */}
                                                                {info.participants && info.participants.length > 0 && (
                                                                    <div style={{ fontSize: '0.85em', marginTop: '8px', color: '#666' }}>
                                                                        <strong>Participants:</strong>
                                                                        <ul style={{ marginTop: '4px', paddingLeft: '20px', marginBottom: 0 }}>
                                                                            {info.participants.map((participant, idx) => (
                                                                                <li key={idx}>
                                                                                    {participant.first_name} {participant.last_name}
                                                                                    {participant.email && ` (${participant.email})`}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {info.event_type && info.event_type !== 'Event' ? (
                                                                    <>{t('home.Event')}:<br />{info.event_type}</>
                                                                ) : (
                                                                    t('home.Event')
                                                                )}
                                                            </td>
                                                            <td>{info.event_language}</td>
                                                            <td>
                                                                {info.city_name}<br />
                                                                {info.start_date}
                                                                <br />
                                                                {
                                                                    info.event_type === '1-Day Workshops' ?
                                                                        (null)
                                                                        :
                                                                        info.end_date
                                                                }

                                                            </td>
                                                            <td>{t('home.NA')}</td>
                                                            <td>
                                                                {info.participants_count || (info.parent * 1 + info.child * 1)}
                                                                {/* {info.venue_address} */}
                                                            </td>

                                                            <td>
                                                                {t('home.INR')} {info.item_total || (info.price * info.parent + info.second_price * info.child)}
                                                            </td>
                                                        </tr>
                                                    )

                                                })
                                                }


                                                {productitem.map((info, ii) => {
                                                    return (
                                                        <tr>
                                                            <td>{eventTestitem.length + eventitem.length + ii + 1}</td>
                                                            <td>{info.title}</td>
                                                            <td>
                                                                {t('home.Product')}:<br />
                                                                {info.type_name}</td>
                                                            <td>{info.product_language}</td>
                                                            <td>{t('home.NA')}</td>

                                                            <td>{info.quantity}</td>
                                                            <td>{t('home.NA')}</td>
                                                            <td>
                                                                {t('home.INR')} {info.price}
                                                            </td>
                                                        </tr>
                                                    )

                                                })
                                                }


                                                {magazineitem.map((info, iii) => {
                                                    return (
                                                        <tr>
                                                            <td>{productitem.length + eventTestitem.length + eventitem.length + iii + 1}</td>
                                                            <td>{info.package_title}</td>
                                                            <td>
                                                                {t('home.Magazine')}:<br />
                                                                {info.magazine_title}</td>
                                                            <td>{info.magazine_language}</td>
                                                            <td>{t('home.NA')}</td>

                                                            <td>-</td>
                                                            <td>{t('home.NA')}</td>
                                                            <td>{t('home.INR')} {info.price * 1}</td>
                                                        </tr>
                                                    )

                                                })
                                                }


                                            </tbody>
                                        </table>




                                    </div>
                                </div>
                            </div>
                            ) : (
                                <div>
                                    {/* <h3>{t('home.Please Register to view your order details')}</h3> */}
                                </div>
                            )}

                            {/* Mobile Design */}
                            {!isGuestUser ? (
                            <div className="d-xl-none d-lg-none d-md-none d-block">
                                <ListGroup>
                                    <ListGroupItem className="bg-light font-weight-bold">
                                        ORDER DETAILS
                                    </ListGroupItem>

                                    {/* Event Test */}
                                    {
                                        eventTestitem.map(info =>
                                            <ListGroupItem >
                                                <Row>
                                                    <Col sm="12" xs="12" style={{ textDecoration: 'underline' }}>
                                                        <span className="font-weight-bold">
                                                            {info.title}
                                                        </span>
                                                    </Col>
                                                    {/* Show participants if available */}
                                                    {info.participants && info.participants.length > 0 && (
                                                        <Col sm="12" xs="12" style={{ marginTop: '10px' }}>
                                                            <span className="font-weight-bold">{t('home.Participants')}:</span>
                                                            <ul style={{ marginTop: '5px', paddingLeft: '20px' }}>
                                                                {info.participants.map((participant, idx) => (
                                                                    <li key={idx} style={{ fontSize: '0.9em' }}>
                                                                        {participant.first_name} {participant.last_name}
                                                                        <br />
                                                                        {participant.email && <span style={{ fontSize: '0.85em', color: '#666' }}>Email: {participant.email}</span>}
                                                                        {participant.mobile && <span style={{ fontSize: '0.85em', color: '#666', marginLeft: '10px' }}>Mobile: {participant.mobile}</span>}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </Col>
                                                    )}
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Type')}
                                                        </span>
                                                        {info.event_type}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Language')}&nbsp;:&nbsp;

                                                        </span>
                                                        {info.event_language}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Details')}&nbsp;:&nbsp;

                                                        </span>
                                                        {t('home.NA')}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Quantity')}&nbsp;:&nbsp;

                                                        </span>
                                                        {t('home.NA')}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.No of Participants')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.participants_count || (info.parent * 1 + info.child * 1)}
                                                    </Col>

                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                                        </span>
                                                        {t('home.INR')} {info.item_total || (info.price * info.parent + info.second_price * info.child)}
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        )
                                    }

                                    {/* Events */}
                                    {
                                        eventitem.map(info =>
                                            <ListGroupItem >
                                                <Row>
                                                    <Col sm="12" xs="12" style={{ textDecoration: 'underline' }}>
                                                        <span className="font-weight-bold">
                                                            {info.title}
                                                        </span>
                                                    </Col>
                                                    {/* Show participants if available */}
                                                    {info.participants && info.participants.length > 0 && (
                                                        <Col sm="12" xs="12" style={{ marginTop: '10px' }}>
                                                            <span className="font-weight-bold">{t('home.Participants')}:</span>
                                                            <ul style={{ marginTop: '5px', paddingLeft: '20px' }}>
                                                                {info.participants.map((participant, idx) => (
                                                                    <li key={idx} style={{ fontSize: '0.9em' }}>
                                                                        {participant.first_name} {participant.last_name}
                                                                        <br />
                                                                        {participant.email && <span style={{ fontSize: '0.85em', color: '#666' }}>Email: {participant.email}</span>}
                                                                        {participant.mobile && <span style={{ fontSize: '0.85em', color: '#666', marginLeft: '10px' }}>Mobile: {participant.mobile}</span>}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </Col>
                                                    )}
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Type')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.event_type && info.event_type !== 'Event' ? (
                                                            <>{t('home.Event')}: {info.event_type}</>
                                                        ) : (
                                                            t('home.Event')
                                                        )}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Language')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.event_language}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Details')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.city_name}<br />
                                                        {info.start_date}
                                                        <br />
                                                        {
                                                            info.event_type === '1-Day Workshops' ?
                                                                (null)
                                                                :
                                                                info.end_date
                                                        }
                                                    </Col>

                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Quantity')}&nbsp;:&nbsp;
                                                        </span>
                                                        {t('home.NA')}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.No of Participants')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.participants_count || (info.parent * 1 + info.child * 1)}
                                                    </Col>

                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                                        </span>
                                                        {t('home.INR')} {info.item_total || (info.price * info.parent + info.second_price * info.child)}
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        )
                                    }

                                    {/* Products */}
                                    {
                                        productitem.map(info =>
                                            <ListGroupItem >
                                                <Row>
                                                    <Col sm="12" xs="12" style={{ textDecoration: 'underline' }}>
                                                        <span className="font-weight-bold">
                                                            {info.title}
                                                        </span>
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Type')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.type_name}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Language')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.product_language}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Quantity')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.quantity}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                                        </span>
                                                        {/* {t('home.INR')} {info.price * info.quantity} */}
                                                        {t('home.INR')} {info.price}
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        )
                                    }


                                    {/* Magazine */}
                                    {
                                        magazineitem.map(info =>
                                            <ListGroupItem >
                                                <Row>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {info.magazine_title}
                                                        </span>
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Type')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.package_title}
                                                    </Col>

                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Language')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.magazine_language}
                                                    </Col>
                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Quantity')}&nbsp;:&nbsp;
                                                        </span>
                                                        {info.quantity}
                                                    </Col>

                                                    <Col sm="12" xs="12">
                                                        <span className="font-weight-bold">
                                                            {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                                        </span>
                                                        {t('home.INR')} {info.price * 1}
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        )
                                    }
                                </ListGroup>
                            </div>
                            ) : (
                                <div>
                                    {/* <h3>{t('home.Please Register to view your order details')}</h3> */}
                                </div>
                            )}
                        </div>
                    </div>
                </div>


                <div class="modal fade z-index--99999" id="cancelOrderModal" style={{ marginTop: '0px' }}>
                    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-l" role="document">
                        <div class="modal-content bg-light">
                            <div class="modal-header" style={{ background: '#9d0b0e', height: '8%' }}>
                                <h5 class="modal-title" id="exampleModalLabel" style={{ marginTop: '-11px', color: 'white', fontSize: '15px' }}>

                                    {t('home.CANCEL ORDER')}
                                </h5>
                                <button style={{ marginTop: '-28px' }} type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <i class="far fa-times-circle"></i>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">

                                    <div class="col">

                                        {t('home.Are you sure you want to cancel this order?')}



                                    </div>
                                </div>
                                <div class="row" style={{ marginTop: '20px' }}>
                                    <div class="col">
                                        <button type="button" class="btn btn-outline-brown bg-white btn-sm mb-2" style={{ color: 'black' }} onClick={this.cancelOrderConfirm}>
                                            {t('home.Cancel Order')}

                                        </button>

                                        <span style={{ color: 'white', cursor: 'pointer', marginLeft: '30px' }} class="btn btn-brown btn-sm mb-2" data-dismiss="modal" aria-label="Close">
                                            {t('home.Dont Cancel')}

                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* <div class="modal-footer">
                    <span data-dismiss="modal" aria-label="Close">Cancel</span>
                    <button type="button" class="btn btn-outline-brown bg-white btn-sm pl-4 pr-4">SAVE</button>
                </div> */}
                        </div>
                    </div>
                </div>



                <Footer />
            </div>
        );
    }
}
Orderdetails.propTypes = {
    t: PropTypes.func.isRequired,
};
export default translate(Orderdetails);

